import React from 'react';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { setTheme } from '~local/actions';

import { Label } from '~ui';

const themes = [
  ['day', { app: 'day', sidebar: 'day' }],
  ['night', { app: 'night', sidebar: 'night' }],
  ['midnight', { app: 'day', sidebar: 'night' }],
  ['sunset', { app: 'sunset', sidebar: 'sunset' }],
];

export default function SettingsAppTheme() {
  const theme = useSelector((state) => state.local.theme);
  const dispatch = useDispatch();

  return (
    <>
      <Label>{t.s('interfaceStyle')}</Label>
      <div>
        <div className={'ui-theme-selector'}>
          {themes.map(([key, item]) => (
            <a
              key={key}
              className={'ui-theme'}
              data-active={
                item.app == theme.app && item.sidebar == theme.sidebar
              }
              tabIndex='0'
              href=''
              onClick={(e) => {
                e.preventDefault();
                dispatch(setTheme(item));
              }}
            >
              <div data-theme={item.sidebar} className={'ui-theme-sidebar'}>
                ―――― ―― ―――
              </div>

              <div data-theme={item.app} className={'ui-theme-main'}>
                <span />
                <span />
                <span />
                <span />
                <span />
              </div>
            </a>
          ))}
        </div>
      </div>
    </>
  );
}
